import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-grid-system';
import LazyLoad from 'react-lazyload';
import HeaderTable from '../../../components/HeaderTable';
import BasketMatchRow from '../../../components/BasketMatchRow';
import Label from '../../../components/shared/Label';

export class WeekTable extends Component {
  getKeys = (matches) => {
    let matchKeys = [];
    [...matchKeys] = matches.keys();
    return matchKeys;
  };

  formatDate = (date) => {
    const options = {
      weekday: 'long', month: 'long', day: '2-digit', timeZone: 'UTC',
    };
    return new Date(date).toLocaleString('it-IT', options);
  };

  isYesterday = (matchDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterdayDate = new Date(today);
    const yesterdayRef = new Date(yesterdayDate.setDate(today.getDate() - 1));
    const currentDay = new Date(matchDate);
    currentDay.setHours(0, 0, 0, 0);
    return yesterdayRef.getTime() === currentDay.getTime();
  };

  isToday = (matchDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const currentDay = new Date(matchDate);
    currentDay.setHours(0, 0, 0, 0);
    return today.getTime() === currentDay.getTime();
  };

  isTomorrow = (matchDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrowDate = new Date(today);
    const tomorrowRef = new Date(tomorrowDate.setDate(today.getDate() + 1));
    const currentDay = new Date(matchDate);
    currentDay.setHours(0, 0, 0, 0);
    return tomorrowRef.getTime() === currentDay.getTime();
  };

  calculateDate = (date) => {
    if (this.isToday(date)) {
      return 'today';
    } else if (this.isTomorrow(date)) {
      return 'tomorrow';
    } else if (this.isYesterday(date)) {
      return 'yesterday';
    }
    return 'other';
  };

  render() {
    const {
      matchDate, matches, dictionary,
      isMobile, hasHighlights, actions,
      groupsPhase, isGroups, isBasketCalendarChampionship,
    } = this.props;
    return (
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0, marginBottom: '35px' }}>
        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <Col md={12} sm={12} xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <LazyLoad offset={20}>
              <HeaderTable
                title={this.formatDate(matchDate)}
                bgColor="tableHeaderColor"
                isGroups={isGroups}
              />
            </LazyLoad>
          </Col>
        </Row>
        {!groupsPhase && matches && matches.size > 0 && matches.map((currentGame, index) => (
          <LazyLoad offset={20} key={index}>
            <BasketMatchRow
              matchRow={currentGame}
              key={index}
              hasHighlights={hasHighlights}
              actions={actions}
              dictionary={dictionary}
              isMobile={isMobile}
              date={this.calculateDate(currentGame.get('date'))}
              sportId={window.matchcenterPage.sportId}
              competitionId={window.matchcenterPage.competitionId}
              isBasketCalendarChampionship={isBasketCalendarChampionship}
            />
          </LazyLoad>
          ))
        }
        {!groupsPhase && matches && matches.size === 0 &&
        <Label
          label="Nessun evento disponibile in questa giornata"
          color="black"
        />
        }
      </Container>
    );
  }
}

WeekTable.propTypes = {
  matchDate: PropTypes.any,
  dictionary: PropTypes.any,
  hasHighlights: PropTypes.bool,
  actions: PropTypes.any,
  isMobile: PropTypes.bool,
  matches: PropTypes.any,
  groupsPhase: PropTypes.bool,
  isGroups: PropTypes.bool,
  isBasketCalendarChampionship: PropTypes.bool,
};

export default WeekTable;



// WEBPACK FOOTER //
// ./src/containers/BasketCalendarNba/WeekTable/index.js